import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'timeFormat',
    pure: false,
})
export class TimeFormatPipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: string): string {
        if (value.indexOf(':') > -1) {
            if (this.translate.currentLang === 'fr') {
                return value;
            }

            const [hours, minutes] = value.split(':').map(Number);
            const date = new Date(0, 0, 0, hours, minutes);

            let options: Intl.DateTimeFormatOptions = { minute: '2-digit' };

            options = { ...options, hour: 'numeric', hour12: true };
            let formattedTime = date.toLocaleString('en-US', options);

            formattedTime = formattedTime.replace(/\bAM\b/g, 'a.m.').replace(/\bPM\b/g, 'p.m.');
            // delete leading zero
            formattedTime = formattedTime.replace(/^0(\d+)/, '$1');
            // delete minuts if 00
            formattedTime = formattedTime.replace(/:00\b/g, '');

            return formattedTime;
        }
        return value;
    }
}
